import React from "react";
import { Alert, Icon, message } from "antd";
import get from "lodash/get";

import { getEmailTemplatePreviewRequest } from "../../api/requests";
import isAuthenticated from "../../utils/isAuthenticated";

import classes from "./EmailTemplates.css";


class EmailTemplatesPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailTemplate: null,
      isLoading: false,
      requestResult: null,
    };
  }

  async componentDidMount() {
    this.getEmailTemplate();
  }

  getEmailTemplate = async () => {
    if (this.props.id) {
      this.setState({ isLoading: true });
      try {
        const { data } = await getEmailTemplatePreviewRequest(this.props.id);
        this.setState({
          emailTemplate: data.replace("<body  class=\"ql-editor\"", '<div'),
        });
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
          return;
        }
        message.error(get(e, "response.data.error", "Error"));
      }

      this.setState({ isLoading: false });
    } else {
      this.setState({
        emailTemplate: {},
      });
    }
  };

  render() {
    const { isLoading, emailTemplate } = this.state;
    return (
      <div>
        {isLoading && <Icon type="loading" />}
        {emailTemplate && (
          <div>
            <br/>
            <h4><b>{this.props.subjectText}</b></h4>
            <br/>
            <div
              dangerouslySetInnerHTML={{
                __html: emailTemplate,
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default isAuthenticated(EmailTemplatesPreview);



// WEBPACK FOOTER //
// ./src/containers/EmailTemplates/EmailTemplatePreview.js